/**
 * 乗車券の取得
 */
export function getFare(course, freePass) {
  var total = 0;
  var prices = course.Price;
  if (prices !== undefined) {
    for (var j = 0; j < prices.length; j++) {
      if (prices[j].kind == "Fare" && prices[j].selected == "true") {
        var notCalculate = false;
        for (var k = parseInt(prices[j].fromLineIndex, 10) - 1; k <= parseInt(prices[j].toLineIndex, 10) - 1; k++) {
          if (getTextValue(course.Route.Line[k].Type) != "car") {
            if (freePass !== undefined) {
              if (notCalculate || getFreePassList(course.Route.Line[k], freePass, getLineCode(k, course.OperationLinePattern)).length == 0) {
                notCalculate = true;
              }
            } else {
              notCalculate = true;
            }
          }
        }
        if (notCalculate) {
          total += parseInt(getTextValue(prices[j].Oneway), 10);
        }
      }
    }
  }
  return total;
}

/**
 * 特急料金の取得
 */
export function getCharge(course) {
  var total = 0;
  var prices = course.Price;
  if (prices !== undefined) {
    for (var j = 0; j < prices.length; j++) {
      if (prices[j].kind == "Charge" && prices[j].selected == "true") {
        total += parseInt(getTextValue(prices[j].Oneway), 10);
      }
    }
  }
  return total;
}

/**
 * text要素を返す
 */
export function getTextValue(obj) {
  return (obj === undefined ? "" : (obj.text !== undefined ? obj.text : obj));
}

/**
 * 通常運賃の金額を取得する
 */
export function getFareAndCharge(course) {
  var totalFare = 0;
  var totalCharge = 0;
  if (course.Ticket !== undefined) {
    var prices = course.Ticket.Price
    for (var i = 0; i < prices.length; i++) {
      if (prices[i].id == "normal") {
        totalFare += parseInt(prices[i].fareSummary)
        totalCharge += parseInt(prices[i].chargeSummary)
      }
    }
  }
  return { totalFare: totalFare, totalCharge: totalCharge };
}

/**
 * フリーパスの合計金額を取得する
 */
export function getFreePass(course) {
  var totalSet = {};
  if (course.Ticket !== undefined) {
    var prices = course.Ticket.Price
    for (var i = 0; i < prices.length; i++) {
      if (prices[i].id != "normal") {
        if (totalSet[prices[i].id] == undefined) totalSet[prices[i].id] = {}
        if (totalSet[prices[i].id]['name'] == undefined) totalSet[prices[i].id]['name'] = prices[i].Name
        if (totalSet[prices[i].id]['freePassPrice'] == undefined) totalSet[prices[i].id]['freePassPrice'] = parseInt(prices[i].freePassPrice)
        if (totalSet[prices[i].id]['otherPrice'] == undefined) totalSet[prices[i].id]['otherPrice'] = 0
        totalSet[prices[i].id]['otherPrice'] += (parseInt(prices[i].fareSummary) + parseInt(prices[i].chargeSummary))
      }
    }
  }
  return totalSet;
}

/**
 * 線区コードを取得する
 */
function getLineCode(index, operationLinePattern) {
  if (operationLinePattern !== undefined) {
    for (var i = 0; i < operationLinePattern.length; i++) {
      if (operationLinePattern[i].routeLineIndex == String(index + 1)) {
        return operationLinePattern[i].Line[0].code;
      }
    }
  }
}

/**
 * フリーパスチェック
 */
function getFreePassList(line, freePass, lineCode) {
  var names = [];
  for (var i = 0; i < freePass.length; i++) {
    for (var j = 0; j < freePass[i].zone.length; j++) {
      if (line.Corporation !== undefined) {
        if (freePass[i].zone[j].corporationName !== undefined) {
          if (line.Corporation.Name == freePass[i].zone[j].corporationName) {
            if (names.indexOf(freePass[i].name) == -1) {
              names.push(freePass[i].name);
            }
          }
        } else if (freePass[i].zone[j].points !== undefined) {
          if (getFreePassSection(line, freePass[i].zone[j], lineCode)) {
            if (names.indexOf(freePass[i].name) == -1) {
              names.push(freePass[i].name);
            }
          }
        } else if (lineCode !== undefined && lineCode == freePass[i].zone[j].lineCode) {
          if (names.indexOf(freePass[i].name) == -1) {
            names.push(freePass[i].name);
          }
        } else if (line.InsideInformation !== undefined && line.InsideInformation.Section !== undefined) {
          if (freePass[i].zone[j].lineName == line.InsideInformation.Section.Name) {
            if (names.indexOf(freePass[i].name) == -1) {
              names.push(freePass[i].name);
            }
          }
        }

      }
    }
  }
  return names;
}

/**
 * フリーパスの区間判定
 */
function getFreePassSection(line, zone, lineCode) {
  if (zone.lineCode !== undefined && lineCode !== undefined) {
    if (zone.lineCode != lineCode) {
      return false;
    }
  } else if (line.InsideInformation !== undefined && line.InsideInformation.Section !== undefined) {
    if (zone.lineName != line.InsideInformation.Section.Name) {
      return false;
    }
  }
  var stations = [];
  stations.push(zone.points);
  stations.push(zone.points.concat().reverse());
  if (line.Stop !== undefined && zoneInPoints(line.Stop, stations)) {
    return true;
  } else {
    return false;
  }
}

/**
 * フリーパスの停車駅
 */
function zoneInPoints(stop, stations) {
  for (var i = 0; i < stations.length; i++) {
    var index = -1;
    var isSuccess = true;
    for (var j = 0; j < stop.length; j++) {
      var checkIndex = stations[i].indexOf(stop[j].Point.Station.code);
      if (index == -1 || (checkIndex !== -1 && checkIndex > index)) {
        index = checkIndex;
      } else {
        isSuccess = false;
      }
    }
    if (isSuccess && index != -1) {
      return true;
    }
  }
  return false;
}
